import { render, staticRenderFns } from "./editCalculateDot.vue?vue&type=template&id=33ced1cb&scoped=true&"
import script from "./editCalculateDot.vue?vue&type=script&lang=js&"
export * from "./editCalculateDot.vue?vue&type=script&lang=js&"
import style0 from "./editCalculateDot.vue?vue&type=style&index=0&id=33ced1cb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ced1cb",
  null
  
)

export default component.exports